import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  const navigate = useNavigate();

  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h4>Dietaro</h4>
          <p>Profesyonel diyetisyen platformu</p>
          <p className="footer-description">
            Diyetisyenler için tasarlanmış, modern ve güvenli platform
          </p>
        </div>
        <div className="footer-section">
          <h4>İletişim</h4>
          <p>faruk@dietaro.com</p>
          <p>+90 (535) 395 91 49</p>
          <p className="footer-hours">
            Pazartesi - Cuma: 08:00 - 18:00
          </p>
          <button
            onClick={() => navigate('/contact')}
            className="footer-visit-button"
          >
            <span className="footer-visit-icon">📍</span>
            <span>Bizi Ziyaret Edin</span>
          </button>
        </div>
        <div className="footer-section">
          <h4>Hızlı Bağlantılar</h4>
          <div className="footer-links">
            <a href="#features">Özellikler</a>
            <a href="/feed" onClick={(e) => { e.preventDefault(); navigate('/feed'); }}>Paylaşımlar</a>
            <a href="/contact" onClick={(e) => { e.preventDefault(); navigate('/contact'); }}>İletişim</a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>
          &copy; 2026 Dietaro. Tüm hakları saklıdır. KVKK uyumlu platform.
        </p>
      </div>
    </footer>
  );
};

export default Footer;

